"use strict";

module.exports = ["Mr.", "Ms.", "Miss", "Mrs.", "Dr.", "Prof."].map((code) => {
  return { display: code, code: code.toUpperCase() };
});
